import { useTranslation } from "next-i18next"

const useMyFavoritesi18n = ({
  componentProps,
  selectedItems,
  isSaveProductToList,
}) => {
  const { t } = useTranslation()
  const i18n = {
    favoriteTitle: isSaveProductToList
      ? t("kf.account.label.myLists")
      : t("kf.favorite.label.favoriteTitle"),
    accountSettings: t("kf.account.label.accountSettings"),
    favorites: isSaveProductToList
      ? t("kf.account.label.myLists")
      : t("kf.account.label.favorites"),
    myLists: t("kf.account.label.myLists"),
    createNewList: t("kf.saveToList.create.header"),
    media: t("kf.account.label.media"),
    lists: t("kf.account.label.lists"),
    orders: t("kf.account.label.orders"),
    myProducts: t("kf.account.label.myProducts"),
    myServices: t("kf.account.label.myServices"),
    myAccount: t("kf.account.label.myAccount"),
    hi: t("kf.account.label.hi"),
    signOut: t("kf.account.label.signOut"),
    myFavorites: t("kf.favorite.label.myFavorites"),
    allTab: t("kf.favorite.label.allTab"),
    productsTab: t("kf.favorite.label.productsTab"),
    imagesTab: t("kf.favorite.label.imagesTab"),
    newToOld: t("kf.favorites.sort.newToOld"),
    oldToNew: t("kf.favorites.sort.oldToNew"),
    videosTab: t("kf.favorite.label.videosTab"),
    articlesTab: t("kf.favorite.label.articlesTab"),
    manageText: t("kf.favorite.label.manageText"),
    sort: t("kf.favorite.label.sort"),
    sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
    sortbyClosed: t("kf.plp.label.sortbyClosed"),
    selected: t("kf.plp.arialabel.selected"),
    altSort: t("kf.plp.label.img.altSort"),
    loadMore: t("kf.favorite.label.loadMore"),
    backToTop: t("kf.favorite.label.backToTop"),
    favoriteDeleteTitle: t("kf.favorite.label.favoriteDeleteTitle"),
    favoritesDeleteMssg: t("kf.favorite.label.favoritesDeleteMssg", {
      count: selectedItems?.length,
    }),
    manageFavorites: t("kf.favorite.label.manageFavorites"),
    selectAll: t("kf.favorite.label.selectAll"),
    UnselectAll: t("kf.favorite.label.UnselectAll"),
    cancel: t("kf.favorite.label.cancel"),
    remove: t("kf.favorite.label.remove"),
    itemCancel: t("kf.favorite.label.itemCancel"),
    itemRemove: t("kf.favorite.label.itemRemove"),
    removeItem: t("kf.favorites.removeItem"),
    continueShopping: componentProps?.continueShoppingText
      ? componentProps?.continueShoppingText
      : t("kf.favorites.label.continueShopping"),
    addToYourFavorites: t("kf.favorites.label.addToYourFavorites"),
    addToCompare: t("kf.plp.label.addToCompare"),
    colors: t("kf.plp.label.colors"),
    color: t("kf.plp.label.color"),
    startingAt: t("kf.plp.label.startingAt"),
    new: t("kf.plp.label.new"),
    sale: t("kf.plp.label.sale"),
    view: t("kf.plp.label.view"),
    items: t("kf.plp.label.items"),
    all: t("kf.plp.label.all"),
    exclusive: t("kf.plp.label.exclusive"),
    newExclusive: t("kf.plp.label.newExclusive"),
    sortByAria: count => t("kf.plp.label.sortByAria", { sortByCount: count }),
    ariaLabel: {
      tabs: (count, tabName) =>
        t("kf.favorite.aria.label.tabs", { count, tabName }),
      allTab: t("kf.favorite.aria.label.allTab"),
      close: t("kf.findStoreUtilNav.label.closeAlt"),
      manageSelected: count =>
        t("kf.favorite.aria.label.manageSelected", { count }),
      remove: t("kf.favorite.label.aria.remove", {
        count: selectedItems?.length,
      }),
      selectedAll: t("kf.favorite.aria.label.selectedAll"),
      favoriteRemoved: t("kf.favorites.removed"),
      hi: t("kf.account.label.hi"),
    },
    availableIn: t("kf.account.label.availableIn"),
    colorOrFinish: t("kf.pdp.label.colorOrFinish"),
    skuItem: t("kf.cart.label.sku"),
  }

  return i18n
}

export default useMyFavoritesi18n
